module.exports = __webpack_public_path__ + "img/invite.e458bb42.svg";